

  
<div #myModal class="modal fade" id="modal-lg">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">¿Está seguro de Eliminar?.</h4>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
  

        <div class="modal-body">
            

            <table class="table table-bordered" style="border-color: transparent;">
                <thead>
                  <tr  style="text-align: center;border-style: none;border-color: transparent;">
                    <th style="width: auto;border-color: transparent"><button type="button" class="btn btn-primary" (click)="OnEliminarCodigo()">SI</button> </th>
                    <th style="width:auto;border-color: transparent"> <button type="button" class="btn btn-danger" (click)="OnCerrarDialogo()">NO</button></th>
                    
                    
                  </tr>
                </thead>
            </table>
         
        
            
         
        </div>
        <div class="modal-footer justify-content-between">
       
         
        </div>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
  </div>
  <!-- /.modal -->


  <section class="content">
      <div class="container-fluid">
        <div class="row">
         
          <!-- left column -->
          <div class="col-md-8">
           
  <div class="card card-primary">
      <div class="card-header">
        <h3 class="card-title">Datos </h3>
      </div>
      <!-- /.card-header -->
      <!-- form start -->
      <form  [formGroup]="formCodigo"   >
        <div class="card-body">
          <div class="form-group">
            <label for="labelImagen1">Escriba un codigo:</label>
            <div class="form-group">

                <input type="text" class="form-control"  placeholder="Escriba aquí" maxlength="30" formControlName="txtDescripcion" >
              </div>
        </div>

        <div class="form-group">
            <label for="labelImagen1">Valor Descuento (%)</label>
            <div class="form-group">

                <input type="number" class="form-control"  placeholder="Escriba aquí" maxlength="30" formControlName="txtDescuento" >
              </div>
        </div>
        <!-- /.card-body -->
  
        
        <div class="card-footer" style="text-align: center;">
            <div *ngIf="esperar == true" class="overlay"><i class="fas fa-3x fa-sync-alt fa-spin"></i><div class="text-bold pt-2">Espere...</div></div>
            <button type="button" class="btn btn-primary" (click)="OnGuardarCodigo()">{{this.tituloBotonGuardar}}</button>
        
           
          </div>
       
        </div>
      </form>
    </div>
  

    <div class="card card-primary">
        <div class="card-header">
          <h3 class="card-title">Lista </h3>
        </div>
  
    <table class="table table-bordered">
        <thead>
          <tr  >
            <th style="width: auto">Código </th>
            <th style="width:auto">Descripción</th>
            
             <th style="width: auto"></th>
          </tr>
        </thead>
        <tbody>
          <tr  *ngFor="let dato of codigodescuentos; let i=index">
            <td >{{dato.idCodigoDescuento}}</td>
            <td>{{dato.descripcion}}</td>
          
            <td >  <a class="btn btn-app" (click)="OnAbrirDialogo(dato.idCodigoDescuento)">
              <i class="fas fa-edit"></i> Eliminar
            </a></td>
          </tr>
          
          
        </tbody>
      </table>
   
    </div>
  
  
  
  
  
  </div>
  </div>
  </div>
  </section>
  
  

